enum SubscriptionUpdateAnchor {
    NOW = 'now',
    CURRENT_PERIOD_END = 'current_period_end',
    MANUAL = 'manual',
}

export default SubscriptionUpdateAnchor;
